import * as React from "react";

import "./Loader.css";

interface IProps {
  visible: boolean;
}

export default class Loader extends React.Component<IProps> {
  public render() {
    const { visible } = this.props;
    return (
      <div className="lds-ring" style={{ opacity: visible ? 1 : 0 }}>
        <div />
        <div />
        <div />
        <div />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loader.tsx